/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const InResourceId: core.serialization.ObjectSchema<serializers.InResourceId.Raw, Truvity.InResourceId> =
    core.serialization.object({
        values: core.serialization.list(core.serialization.string()),
    });

export declare namespace InResourceId {
    export interface Raw {
        values: string[];
    }
}
